module.exports = __webpack_public_path__ + "img/closeIconBlack.e51cd81a.svg";